import React, { useState } from 'react'
import { Box, Modal, Typography, useTheme } from '@mui/material'
import AuthorizedLinkItem from './AuthorizedLinkItem'
import ContactLinkItem from './ContactLinkItem'
import { useUser } from '../../../api/aws/useUser'
import DetailsLoading from '../../Loading/DetailsLoading'
import { handleCopy } from '../utils/handleCopy'

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  width: '50vw',
  p: 4,
}

const ViewLinksModal = ({ isOpen, onClose, deal }) => {
  const [isAuthCopied, setIsAuthCopied] = useState(false)
  const [isContactCopied, setIsContactCopied] = useState(false)
  const { user: authorizedUser, isUserLoading, isUserError } = useUser(
    deal?.recipients?.authorizedRecipient?.[0]?.id,
    'authorizedUser'
  )
  // const { data: contact, isLoading: isContactLoading, isError: isContactError } = useContact(
  //   deal?.recipients?.contactRecipient?.[0]?.id,
  //   ['contact', 'contactRecipient', deal?.recipients?.contactRecipient?.[0]?.id]
  // )
  const theme = useTheme()

  if (isUserLoading) {
    return <DetailsLoading />
  }
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...modalStyle, display: 'flex', flexDirection: 'column', gap: 7 }}>
        <Typography id="enter-link-emails-typography" variant="h6" component="h2">
          {`Generated Links for ${deal?.name}`}
        </Typography>
        <AuthorizedLinkItem
          label={'Authorized Link'}
          onCopy={() => handleCopy(deal?.authorizedDocumentLink, setIsAuthCopied)}
          isCopied={isAuthCopied}
          linkContent={deal?.authorizedDocumentLink}
          imageUrl={authorizedUser?.image_512}
        />
        <ContactLinkItem
          label={'Contact Link'}
          onCopy={() => handleCopy(deal?.contactDocumentLink, setIsContactCopied)}
          isCopied={isContactCopied}
          linkContent={deal?.contactDocumentLink}
        />
      </Box>
    </Modal>
  )
}

export default ViewLinksModal
